export default {
    fileUploadConfig: {
        page: {
            StorageType: 'Storage Type',
            ViewConfiguration: 'View Capacity Configuration',
        },
        table: {
            Grouping: 'Group',
            UploadDirectory: 'Upload Directory',
            FileClassification: 'File Classification',
            FileFormat: 'File Format',
            limitSize: 'File Size Limit',
            unitSize: 'File Size Unit',
        },
        dialog: {
            Grouping: 'Group',
            UploadDirectory: 'Upload Directory',
            FileClassification: 'File Classification',
            FileFormat: 'File format',
            limitSize: 'File Size Limit',
            EditTitle: 'Edit upload detailed configuration',
            CreateTitle: 'Create new upload detailed configuration'
        },
    },
};
